/* Keep Mantine's animation, but inherit the card's ink instead of painting white blocks. */
.value::before,
.value::after {
  background: currentColor;
}
.value::before {
  opacity: 0.06;
}
.value::after {
  opacity: 0.16;
  animation-name: pulse;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.22;
  }
}
@media (prefers-reduced-motion: reduce) {
  .value::after {
    animation: none;
  }
}
